import axios from 'axios';
import { CATALOG_API_CONFIG } from '../config/apiConfig';

export async function subjectGetAll({ term, token }) {
  // Construct API URL based on environment
  const baseUrl = CATALOG_API_CONFIG.baseUrl;
  const path = CATALOG_API_CONFIG.subjectsPath;
  const api = `${baseUrl}${path}?sl=Y&term=${term}`;

  console.log('[classAPIs] Fetching subjects from:', api);

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let res = [];

  await axios.get(api, headers).then((response) => {
    res = response.data;
  });

  return res;
}
